import React, {useEffect, useState} from "react";
import StyledPopup from "../CommonComponents/StyledPopup/StyledPopup";
import Box from "@mui/material/Box";
import ClipAggregateOptions from "./ClipAggregateOptions";
import {getEventsInfo, getPlayerInfo, getTemplates} from "../../queries/clipAggregatQuierie";
import {AggregationTypes, Clip, MamClipPlatform} from "../../types/mamTypes";
import {getCompetitionMatchDays, getCompetitions} from "../../queries/competitionQueries";
import {Competition} from "../../types/competitionTypes";
import DraggableListComponent from "../CommonComponents/DragAndDropComponent/DraggableListComponent";
import Grid from "@mui/material/Grid";
import CardClipComponent from "../CommonComponents/CardClipComponent/CardClipComponent";
import {createPhysicalHighlight} from "../../queries/mamPageQueries";
import {Typography} from "@mui/material";
import {useTheme} from "../../contexts/theme";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

interface ClipAggregatePopupProps {

    isOpen: boolean;
    handleClose: () => void;
    handleErrorMessage: (error: boolean, message: string) => void;
    errorMessage : {error: boolean, message: string}
}

const ClipAggregatePopup: React.FC<ClipAggregatePopupProps> = ({isOpen, handleClose, handleErrorMessage, errorMessage}) => {

    const theme = useTheme()

    const [typeOfAggregation, setTypeOfAggregation] = useState<string>('')
    const [events, setEvents ] = useState<{
        id: string,
        name: string,
    }[]>([])

    const [playerString, setPlayerString] = useState<string>('');
    const [selectedPlayer, setSelectedPlayer] = useState<string>('');
    const [players, setPlayers] = useState<string[]>([])
    const [competitions, setCompetitions] = useState<Competition[]>([])
    const [eventString, setEventString] = useState<string>('')
    const [competitionSelected, setCompetitionSelected] = useState<Competition>({
        id : '',
        name : '',
        season : '',
        type : ''
    })

    const [clips, setClips] = useState<MamClipPlatform[]>([])
    const [selectedMatchDay, setSelectedMatchDay] = useState<string>('')
    const [numbering, setNumbering] = useState<boolean>(false);
    const [sort, setSort] = useState<"asc" | "desc">("asc")



    const handleChangeSort = (value: "asc" | "desc") => {
        setSort(value)
    }

    const handleSetClip = (clip: MamClipPlatform[]) => {
        setClips(clip)
    }

    const [selectedEvent, setSelectedEvent] = useState<{
        id: string,
        name: string,
    }>({
        id : "",
        name: "",
    })

    const handleChangeEvent = (event : {id: string, name: string}) => {
        if (event) {
            setSelectedEvent(event)
        }else{
            setSelectedEvent({
                id: "",
                name: ""
            })
        }
    }

    useEffect(() => {
        if (playerString !== '')
            retrievePlayer();
    }, [playerString]);


    const handleChangeMatchDay = (matchday: string) => {
        setSelectedMatchDay(matchday)
    }

    const handleGetTemplates = async () => {

        try {
            const response = await getTemplates(selectedPlayer, typeOfAggregation, Number(selectedMatchDay), competitionSelected.id, selectedEvent.id);
            setClips(response);
        } catch (errorTemplates) {
            console.error(errorTemplates)
        }
    }




    const handleChangeTypeOfAggregation = (value: string) => {
        setTypeOfAggregation(value)
        setSelectedPlayer("")
        setSelectedEvent({
            name: "",
            id: ""
        })
        setPlayers([])
        setEvents([])
        setSelectedMatchDay("")
        setCompetitionSelected({
            id : '',
            name : '',
            season : '',
            type : ''
        })
        if (value === AggregationTypes.BestOfTheDay || value === AggregationTypes.GoalParade || value === AggregationTypes.BestOfTheSeason || value === AggregationTypes.BestActionOfTheDay) {
            getCompetitions().then(response => {
                setCompetitions(response)
            })
        }

    }

    const retrieveEventInfo = async (searchQuery: string) => {
        try {
            return await getEventsInfo(searchQuery);
        } catch (error) {
           handleErrorMessage(
               true,
               "Error to fetch event informations"
           )
        }
    }

    useEffect(() => {
        retrieveEventInfo(eventString).then(response => {
            setEvents(response)
        })
    }, [eventString]);

    const retrievePlayer = async () => {



        try{
            const response = await getPlayerInfo(playerString, selectedEvent.id, Number(selectedMatchDay), competitionSelected.id);



            setPlayers(response.players)
        }catch (errorPlayer) {
            handleErrorMessage(
                true,
                "Error to fetch players"
            )
        }
    }

    const handleChangePlayer = (name: string) => {
        setSelectedPlayer(name)
    }

    const handleInsertPlayer = (value: string) => {
        setPlayerString(value)
    }

    const handleInsertEvent = (value: string) => {
        setEventString(value)
    }

    const handleChangeCompetition = (competition : Competition) => {
        setCompetitionSelected(competition)
    }

    const deleteSpecificClip = (idClip: string) => {
        setClips((prev) => prev.filter((clip) => clip.id !== idClip));
    }

    const handleNumbering = (value: boolean) => {
        setNumbering(value)
    }

    const handleChangeClip = (id: string) => {
        setClips(prevState => {
            const targetClip = prevState.find(c => c.id === id)

            if (targetClip){
                targetClip.selected = !targetClip.selected
            }

            return [...prevState]

        })


    }


    const handlePopupClose = () => {
        setSelectedPlayer("")
        setCompetitionSelected({
            id: "",
            type: "",
            season: "",
            name: ""
        })
        setSelectedMatchDay("")
        setSelectedEvent({
            name: "",
            id: ""
        })
        setTypeOfAggregation("")
        setClips([])
        setNumbering(false)

        handleClose()
    }

    const handleCreateHighlight = async () => {



        const body: any = { clips: [] as Array<{ id: string }> };
        if (clips.length > 0) {
            clips.forEach((clipItem: any) => {
                if (clipItem.id && clipItem.selected === true) {
                    if (!body.clips.includes(clipItem.id)) {
                        body.clips.push({id: clipItem.id});
                    }
                }
            });

                body.fade = false
                body.fade_duration = 0
                body.numbering = numbering
                body.sorting = sort
                body.profiles = ['preview']
                body.highlight_type = typeOfAggregation.charAt(0).toUpperCase() + typeOfAggregation.slice(1);
                body.player = selectedPlayer

            try {

                handleErrorMessage(
                    true,
                    "Current highlight creation..."
                )
                const response = await createPhysicalHighlight(body, false);
                if (response) {
                    handleErrorMessage(
                        true,
                        "Highlight successfully created. "
                    )
                }
            } catch (error) {
                console.error("Failed to create highlight: ", error);
                handleErrorMessage(
                    true,
                    "Failed Highlight Creation. "
                )
            }
        }else{
            handleErrorMessage(
                true,
                "You must select at least one clip to create an aggregate content"
            )
        }
    };




    return (<>

        <StyledPopup
            width={'100vw'}
            isOpen={isOpen}
            onClose={handlePopupClose}
            height={'80vh'}
            title={"Create Aggregates"}>
            <Box>

                <Grid container spacing={2}>
                    <Grid item md={2} xs={12}>
                        <ClipAggregateOptions
                            handleChaneTypeAggregate={handleChangeTypeOfAggregation}
                            typeAggregate={typeOfAggregation}
                            eventsInfo={events}
                            handleChangeEvent={handleChangeEvent}
                            players={players}
                            handleChangePlayer={handleChangePlayer}
                            eventSelected={selectedEvent}
                            playerSelected={selectedPlayer}
                            handleInsertPlayer={handleInsertPlayer}
                            competition={competitions}
                            handleChangeCompetition={handleChangeCompetition}
                            handleChangeMatchDay={handleChangeMatchDay}
                            competitionSelected={competitionSelected}
                            selectedMatchDay={selectedMatchDay}
                            handleInsertEvent={handleInsertEvent}
                            handleGetTemplates={handleGetTemplates}
                            numbering={numbering}
                            handleNumbering={handleNumbering}
                            handleCreationHighlight={handleCreateHighlight}
                            sort={sort}
                            handleSort={handleChangeSort}
                            disableCreateHighlight={(clips.filter(clip => clip.selected === true).length === 0)}
                        />
                    </Grid>

                    <Grid item xs={12} md={10}>

                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            sx={{maxHeight: 700, overflowY: 'auto'}}
                        >
                            {clips.length > 0 ?
                                (
                                    <DraggableListComponent viewTag={false} mode={"template"} items={clips} setItems={handleSetClip} deleteClipDraggable={deleteSpecificClip} overflowY={'auto'} overflowX={'none'} gap={2} flexWrap={'wrap'} handleChangeClipSelection={handleChangeClip} />
                                ) : (
                                    <Box display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} height={'80vh'}>
                                        <Typography variant="h5" color={theme.palette.white}>
                                            No filter specified
                                        </Typography>
                                        <Typography color={theme.palette.white}>
                                            <ManageSearchIcon fontSize={'large'}/>
                                        </Typography>


                                    </Box>


                                )
                            }

                        </Box>


                    </Grid>

                </Grid>






            </Box>

        </StyledPopup>

    </>)
}

export default ClipAggregatePopup;